import React, { useEffect, useState } from 'react';
import './DisplayQuestionOverlay.css';

/**
 * DisplayQuestionOverlay - Displays interview questions on screen for cheating detection.
 *
 * The question is shown in the center of the screen, and the bot says
 * "please answer the question displaying on your screen" instead of speaking it.
 */
const DisplayQuestionOverlay = ({ question, questionId, isVisible, onDismiss }) => {
  const [elapsedTime, setElapsedTime] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  // Timer to show how long the question has been displayed
  useEffect(() => {
    let timer;
    if (isVisible) {
      setElapsedTime(0);
      setIsAnimating(true);
      timer = setInterval(() => {
        setElapsedTime(prev => prev + 1);
      }, 1000);
    } else {
      setIsAnimating(false);
    }
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [isVisible]);

  // Format elapsed time as mm:ss
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  if (!isVisible || !question) {
    return null;
  }

  return (
    <div className={`display-question-overlay ${isAnimating ? 'animate-in' : ''}`}>
      <div className="display-question-container">
        <div className="display-question-header">
          <div className="question-indicator">
            <span className="pulse-dot"></span>
            <span className="indicator-text">Interview Question</span>
          </div>
          <div className="question-timer">
            {formatTime(elapsedTime)}
          </div>
        </div>

        <div className="display-question-content">
          <p className="question-text">{question}</p>
        </div>

        <div className="display-question-footer">
          <p className="instruction-text">
            Please answer this question verbally. The display will automatically dismiss when you finish speaking.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DisplayQuestionOverlay;
